import React from 'react'
import PropTypes from 'prop-types'
import * as Auth from '@morningtrain/react-auth'
import {
  useResource,
  ExecuteOperationOnPipe,
  ExecuteOperationForModelOnPipe
} from '@morningtrain/react-resources'
import { ConfirmPipe } from 'support/pipelines'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import Button from 'ui/buttons/Button'

export default function PermittedConfirmModelAction (props) {
  const { namespace, slug } = useResource()
  const { operation, label, children, confirmProps, data, refreshModel } = props

  return (
    <Auth.CanUseModel permission={`${namespace}.${slug}.${operation}`}>
      <Pipeline>
        <TriggerPipelineOnClick>
          <Button text={label} width='full' />
        </TriggerPipelineOnClick>
        <ConfirmPipe {...confirmProps}>
          {children}
        </ConfirmPipe>
        <ExecuteOperationForModelOnPipe operationName={operation} data={data} />
        {refreshModel ? (
          <ExecuteOperationForModelOnPipe operationName='read' />
        ) : null}
        <ExecuteOperationOnPipe operationName='index' />
      </Pipeline>
    </Auth.CanUseModel>
  )
}

PermittedConfirmModelAction.defaultProps = {
  confirmProps: {},
  operation: null,
  refreshModel: false,
  label: 'Action',
  data: {}
}

PermittedConfirmModelAction.prototypes = {
  confirmProps: PropTypes.object,
  operation: PropTypes.string.isRequired,
  refreshModel: PropTypes.bool,
  label: PropTypes.string,
  data: PropTypes.object
}
